const CareerCtaSection = () => {
  const handleScrollToOpenings = () => {
    document.querySelector("#roles")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="bg-white py-16 md:py-20 px-4">
      <div className="container mx-auto">
        <div
          className="rounded-2xl px-8 py-10 md:px-12 md:py-12 flex flex-wrap items-center justify-between gap-8"
          style={{ background: "#0c0f49" }}
        >
          <div>
            <p className="text-secondary font-poppins text-sm font-extrabold tracking-widest uppercase mb-4">
              Your next chapter
            </p>
            <h2 className="text-white font-poppins font-black tracking-[-0.03em] leading-tight text-3xl md:text-4xl m-0">
              Do work that people can feel.
            </h2>
          </div>

          <button
            type="button"
            onClick={handleScrollToOpenings}
            className="bg-secondary text-primary font-poppins font-extrabold rounded-xl inline-flex items-center gap-3 px-6 py-4 custom-btn focus:outline-none"
          >
            See all open roles <span aria-hidden="true">↑</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default CareerCtaSection;
